import React from 'react';
import { OrderDetailsProps } from '../types/components';
import { paymentMethodOptions } from '../../../../core/data/options/options';

const OrderDetails = ({ summaryData }: OrderDetailsProps) => {
    return (
        <div>
            <div className="form-group">
                <label>Usuario</label>
                <input
                    type="text"
                    className="form-control"
                    value={summaryData.user.label}
                    readOnly
                />
            </div>
            <div className="form-group">
                <label>Métodos de Pago</label>
                <input
                    type="text"
                    className="form-control"
                    value={
                        paymentMethodOptions.find(
                            (option: any) => option.value === summaryData.paymentMethods
                        )?.label || ''
                    }
                    readOnly
                />
            </div>
            <div className="form-group">
                <label>Número de Operación</label>
                <input
                    type="text"
                    className="form-control"
                    value={summaryData.operationNumber}
                    readOnly
                />
            </div>
        </div>
    )
}

export default OrderDetails;